import React, { useContext, useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import ModalSave from "../common/ModelSave";
import { CancelButton, SaveButton } from "../common/Button";
import {
  Row,
  Col,
  Form,
  Modal,
  Container,
  InputGroup,
  Button,
} from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../utils/context";
import JoditEditor from "jodit-react";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ImageValidation } from "../../utils/common";
import { ValidationImage } from "../../utils/api";

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, getDimension } = useContext(Context);
  const {
    control,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    watch,
    setValue,
    reset,
  } = useForm();
  const id = props.selectedId;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const onSubmit = async (data) => {
    try {
      console.log(data);
      const finalData = new FormData();
      finalData.append("booking_id", id);
      finalData.append("driver_name", data?.driver_name);
      finalData.append("driver_number", data?.driver_number);
      finalData.append("cab_number", data?.cab_number);
       finalData.append("vehicle_name", data?.vehicle_name);
      const response = await postData(`/booking`, finalData);
    
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };
  const cabType = props.cabType;

  return (
    <>
      <div className="prodcuttttt">
        <Offcanvas
          show={props.show}
          style={{ width: "80%" }}
          placement={"end"}
          onHide={props.handleClose}
          className="prodcuttttt-offcanvas"
        >
          <Offcanvas.Header closeButton>
            {/* <Offcanvas.Title>Add Employee</Offcanvas.Title> */}
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5  rounded card card">
              <Card.Body>
                <Card.Title>Add Booking Details</Card.Title>
                <hr />
                <Container>
                  <Form
                    // onSubmit={() => handleSubmit(onSubmit)}
                    role="form"
                    // className="stateclass"
                  >
                    <Row>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Cab Type</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="cab_number"
                                  placeholder="Cab type .."
                                  value={cabType}
                                />
                              </InputGroup>
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Cab Number</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="cab_number"
                                  placeholder="Cab Number .."
                                  className={classNames("", {
                                    "is-invalid": errors?.cab_number,
                                  })}
                                  {...register("cab_number", {
                                    required: "Cab number is required",
                                  })}
                                />
                              </InputGroup>
                              {errors.cab_number && (
                                <span className="text-danger">
                                  {errors.cab_number.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Driver Name</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="driver_name"
                                  placeholder="Name .."
                                  className={classNames("", {
                                    "is-invalid": errors?.driver_name,
                                  })}
                                  {...register("driver_name", {
                                    required: "Driver Name is required",
                                  })}
                                />
                              </InputGroup>
                              {errors.driver_name && (
                                <span className="text-danger">
                                  {errors.driver_name.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Driver Mobile No</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="driver_number"
                                  placeholder="Driver Number .."
                                  className={classNames("", {
                                    "is-invalid": errors?.driver_number,
                                  })}
                                  {...register("driver_number", {
                                    required: "driver number is required",
                                  })}
                                />
                              </InputGroup>
                              {errors.driver_number && (
                                <span className="text-danger">
                                  {errors.driver_number.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Vehicle Name</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="vehicle_name"
                                  placeholder="Name .."
                                  className={classNames("", {
                                    "is-invalid": errors?.vehicle_name,
                                  })}
                                  {...register("vehicle_name", {
                                    required: "Vehicle Name is required",
                                  })}
                                />
                              </InputGroup>
                              {errors.vehicle_name && (
                                <span className="text-danger">
                                  {errors.vehicle_name.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Row className="mt-5 pb-3">
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name={"cancel"}
                              handleClose={props.handleClose}
                            />
                          </Link>

                          <SaveButton
                            name={"save"}
                            handleSubmit={handleSubmit(onSubmit)}
                          />
                        </div>
                      </Row>
                    </Row>
                  </Form>
                </Container>
              </Card.Body>
            </Card>
          </Offcanvas.Body>
        </Offcanvas>

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </div>
    </>
  );
};

export default AddOffCanvance;
